import './index.css';

export default {
  name: 'Areminder',
  props: {
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    width: { type: String, default: () => '320' },
    trigger: { type: String, default: () => 'click' },
    placement: { type: String, default: () => 'bottom-end' },
  },
  render() {
    const { ...attrs } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    return (
      <div class="a-reminder">
        <el-popover placement={this.placement} width={this.width} trigger="click" {...{ attrs }}>
          {data.length > 0 ? data.map((a, b) => (
            <div key={b}>
              <div class="label">{a.text || a.label || a.title}</div>
              <div class="value">{a.data || a.value || a.content}</div>
            </div>
          )) : <div>暂无提醒事项</div>}
          <i slot="reference" class="el-icon-bell" />
        </el-popover>
      </div>
    );
  }
}